import React, { ReactNode } from 'react';
import { Modal } from 'antd';

export interface CloseableModalProps {
  title: ReactNode;
  visible: boolean;
  loading?: boolean;
  alignment?: number;
  centered?: boolean;
  children: React.ReactNode;
  className?: string;
  footer?: React.ReactNode;
  onOk?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onCancel?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  style?: React.CSSProperties;
  bodyStyle?: React.CSSProperties;
  width?: string | number;
  icon?: ReactNode;
  onClose?: () => void;
}

export default function CloseableModal({
  title,
  loading = false,
  visible,
  centered = true,
  onCancel,
  children,
  onOk,
  footer = null,
  style,
  bodyStyle,
  width,
}: CloseableModalProps) {
  return (
    <Modal
      title={title}
      centered={centered}
      confirmLoading={loading}
      open={visible}
      footer={footer}
      onCancel={onCancel}
      className="modalStyle flex"
      destroyOnClose={true}
      onOk={onOk}
      style={style}
      styles={{
        body: bodyStyle,
      }}
      width={width}
      closeIcon={null}
    >
      {children}
    </Modal>
  );
}
